import { createStore } from 'vuex'

export default createStore({
  state: {
    // data: {}
    date: '',
    time: '',
    area: '',
    cases: [
      {
        location: '北部地區',
        case: [
          {
            title: '逸居-台北市驗屋',
            name: '台北-誠美頤樺',
            area: '台北中正區',
            date: '202010',
            address: '台北市中正區忠孝東路二段23號',
            type: '電梯大樓',
            link: '719',
            thumbnail: '../images/case/誠美頤樺.jpg'
          },
          {
            title: '逸居-台北市驗屋',
            name: '台北-勤耕延吉',
            area: '台北松山',
            date: '20210508',
            address: '台北市松山區光復南路46巷36號',
            type: '電梯大樓',
            link: '0719',
            thumbnail: '../images/case/勤耕延吉.jpg'
          },
          {
            title: '逸居-新北市驗屋',
            name: '新北-親愛的House',
            area: '新北林口',
            date: '201905',
            address: '新北市林口區文化二路一段',
            type: '電梯大樓',
            link: '0720-a',
            thumbnail: '../images/case/親愛的House.jpg'
          },
          {
            title: '逸居-新北市驗屋',
            name: '新北-國泰上城',
            area: '新北土城',
            date: '202108',
            address: '新北市土城區學士路33巷2-1號',
            type: '電梯大樓',
            link: '0707',
            thumbnail: '../images/case/國泰上城.jpg'
          },
          {
            title: '逸居-新北驗屋',
            name: '新北-四季晏',
            area: '新北汐止',
            date: '202103',
            address: '新北市汐止區樟樹二路167號',
            type: '電梯大樓',
            link: '0619',
            thumbnail: '../images/case/四季宴.jpg'
          },
          {
            title: '逸居-新北驗屋',
            name: '新北-金鶯花園',
            area: '新北鶯歌',
            date: '202102',
            address: '新北市鶯歌區黃厝巷',
            type: '電梯大樓',
            link: '0629',
            thumbnail: '../images/case/金鶯花園.jpg'
          },
          {
            title: '逸居-新北驗屋',
            name: '新北-漢寶之丘',
            area: '新北中和',
            date: '202104',
            address: '新北市中和區興南路一段25號',
            type: '電梯大樓',
            link: '0613-1',
            thumbnail: '../images/case/漢寶之丘.jpg'
          },
          {
            title: '逸居-新北驗屋',
            name: '新北-薇閣博閱',
            area: '新北汐止',
            date: '202008',
            address: '新北市汐止區康寧街383號',
            type: '電梯大樓',
            link: '0608-1',
            thumbnail: '../images/case/薇閣博閱.jpg'
          },
          {
            title: '逸居-桃園驗屋',
            name: '桃園-京耀富達',
            area: '桃園平鎮',
            date: '202102',
            address: '桃園市平鎮區廣達街9號',
            type: '電梯大樓',
            link: '0621',
            thumbnail: '../images/case/京耀富達.jpg'
          },
          {
            title: '逸居-桃園驗屋',
            name: '桃園-佳陞運動家',
            area: '桃園市桃園區',
            date: '202103',
            address: '桃園市桃園區吉安一街58巷1號',
            type: '電梯大樓',
            link: '0628',
            thumbnail: '../images/case/佳陞運動家.jpg'
          },
          {
            title: '逸居-桃園驗屋',
            name: '桃園-宜誠玓瓅',
            area: '桃園市桃園區',
            date: '202108',
            address: '桃園市桃園區大興西路三段及永安路口',
            type: '透天',
            link: '0618',
            thumbnail: '../images/case/宜誠玓瓅.jpg'
          },
          {
            title: '逸居-桃園驗屋',
            name: '桃園-金捷市',
            area: '桃園市龜山區',
            date: '202103',
            address: '桃園市龜山區樂善二路181號',
            type: '電梯大樓',
            link: '0604',
            thumbnail: '../images/case/金捷市.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-寶睿市政',
            area: '新竹市北區',
            date: '202012',
            address: '新竹市北區北大路166巷67號',
            type: '電梯大樓',
            link: '0605',
            thumbnail: '../images/case/寶瑞市政.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-興希望',
            area: '新竹縣竹北市',
            date: '202106',
            address: '新竹縣竹北市北新一街30號',
            type: '電梯大樓',
            link: '0606',
            thumbnail: '../images/case/興希望.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-賦居',
            area: '新竹市北區',
            date: '202012',
            address: '新竹市北區湳雅街313巷32弄12號5號',
            type: '電梯大樓',
            link: '0627',
            thumbnail: '../images/case/賦居.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-德鑫一笈',
            area: '新竹縣竹北市',
            date: '202101',
            address: '新竹縣竹北市興隆路一段與台科路交叉口',
            type: '電梯大樓',
            link: '0608',
            thumbnail: '../images/case/德鑫一笈.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-廣僑樹',
            area: '新竹縣新豐鄉',
            date: '202107',
            address: '新竹縣新豐鄉建興路二段691-1號',
            type: '電梯大樓',
            link: '0609',
            thumbnail: '../images/case/廣僑樹.jpg'
          },
          {
            title: '逸居-新竹驗屋',
            name: '新竹-京茂River1',
            area: '新竹縣竹北市',
            date: '202009',
            address: '新竹縣竹北市興隆路二段327號302302',
            type: '電梯大樓',
            link: '0610',
            thumbnail: '../images/case/新竹京茂.jpg'
          },
          {
            title: '​逸居-苗栗驗屋',
            name: '苗栗-遠雄新苑',
            area: '苗栗縣竹南鎮',
            date: '202011',
            address: '苗栗縣竹南鎮大埔一街18號',
            type: '透天',
            link: '0717',
            thumbnail: '../images/case/遠雄新苑.jpg'
          },
          {
            title: '​逸居-苗栗驗屋',
            name: '苗栗-輕井澤8期',
            area: '苗栗縣苗栗市',
            date: '202101',
            address: '苗栗縣苗栗市至公路351巷5號',
            type: '',
            link: '0603',
            thumbnail: '../images/case/輕井澤8期.jpg'
          },
          {
            title: '​逸居-苗栗驗屋',
            name: '苗栗-真愛NO.1',
            area: '苗栗縣銅鑼鄉',
            date: '202105',
            address: '苗栗縣銅鑼鄉中興一街39號',
            type: '',
            link: '0612',
            thumbnail: '../images/case/真愛NO1.jpg'
          }
        ]
      },
      {
        location: '中部地區',
        case: [
          {
            title: '​逸居-台中驗屋',
            name: '台中-MY雋',
            area: '台中市南屯區大墩路大墩14街口',
            date: '202107',
            address: '',
            type: '',
            link: '0822-2',
            thumbnail: '../images/case/MY雋.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-高鐵一匯',
            area: '台中烏日',
            date: '201907',
            address: '台中市烏日區三和里13鄰三榮北一路17號',
            type: '電梯大樓',
            link: '0618-1',
            thumbnail: ''
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-佳茂敦品',
            area: '台中太平',
            date: '201907',
            address: '台中市太平區新興路172號',
            type: '電梯大樓',
            link: '0729',
            thumbnail: '../images/case/佳茂.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-登陽仰峰',
            area: '台中市北屯區',
            date: '201905',
            address: '台中市北屯區松竹路一段937號',
            type: '',
            link: '0506',
            thumbnail: '../images/case/登陽仰峰.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-微笑世紀',
            area: '台中市北區',
            date: '201906',
            address: '台中市北區育隆路2號',
            type: '',
            link: '0525-house',
            thumbnail: '../images/case/微笑世紀.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-夢蝶莊',
            area: '台中市霧峰區',
            date: '201906',
            address: '台中市霧峰區新埔路211巷',
            type: '透天',
            link: '0624',
            thumbnail: '../images/case/夢蝶莊.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-泰若天成',
            area: '台中市北屯區',
            date: '201906',
            address: '台中市北屯區河北二街36號',
            type: '電梯大樓',
            link: '0620-a',
            thumbnail: '../images/case/泰若天成.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-Hello City',
            area: '台中市霧峰區',
            date: '201912',
            address: '台中市霧峰區五福路278號',
            type: '',
            link: '0614',
            thumbnail: '../images/case/Hello-city.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-Green 1',
            area: '台中市西屯區',
            date: '202104',
            address: '台中市西屯區漢翔路135號',
            type: '',
            link: '0613-1',
            thumbnail: '../images/case/Green1.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-Green HB',
            area: '台中市西屯區',
            date: '202105',
            address: '台中市西屯區台灣大道四段福林路口',
            type: '',
            link: '0614-1',
            thumbnail: '../images/case/Green-HB.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-櫻花綴綻',
            area: '台中市烏日區',
            date: '202006',
            address: '台中市烏日區榮和路88號',
            type: '透天',
            link: '0806',
            thumbnail: '../images/case/櫻花綴綻.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-馥麗5',
            area: '台中市沙鹿區',
            date: '202105',
            address: '台中市沙鹿區星河路',
            type: '透天',
            link: '0721',
            thumbnail: '../images/case/馥麗5.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-鴻邑璞麗',
            area: '台中市北屯區',
            date: '202101',
            address: '台中市北屯區太原路三段1216號',
            type: '電梯大樓',
            link: '0723',
            thumbnail: '../images/case/鴻邑璞麗.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-親家愛家',
            area: '台中市大里區',
            date: '202005',
            address: '台中市大里區大里路316號',
            type: '電梯大樓',
            link: '0818',
            thumbnail: '../images/case/親家愛家.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-興富發-博識',
            area: '台中市南屯區',
            date: '202008',
            address: '台中市南屯區河南路四段No. 522, No. 408',
            type: '電梯大樓',
            link: '0615',
            thumbnail: '../images/case/興富發-博識.jpg'
          },
          {
            title: '​逸居-台中驗屋',
            name: '台中-森堡富',
            area: '台中市清水區',
            date: '201908',
            address: '台中市清水區中華路101巷',
            type: '透天',
            link: '0626',
            thumbnail: '../images/case/森堡富.jpg'
          },
          {
            title: '​逸居-南投驗屋',
            name: '南投-豐璽精湛',
            area: '南投縣埔里鎮',
            date: '202107',
            address: '南投縣埔里鎮中山路三段565號',
            type: '透天',
            link: '0813',
            thumbnail: '../images/case/豐璽精湛.jpg'
          },
          {
            title: '​逸居-南投驗屋',
            name: '南投-富祥安',
            area: '南投縣草屯鎮',
            date: '202101',
            address: '南投縣草屯鎮太平路一段351巷115號',
            type: '電梯大樓',
            link: '0703',
            thumbnail: '../images/case/富祥安.jpg'
          },
          {
            title: '​逸居-南投驗屋',
            name: '南投-時尚寬心',
            area: '南投縣南投市彰南路三段536號',
            date: '202103',
            address: '南投縣南投市',
            type: '電梯大樓',
            link: '0704',
            thumbnail: '../images/case/時尚寬心.jpg'
          },
          {
            title: '​逸居-彰化驗屋',
            name: '彰化-臻品苑',
            area: '彰化縣員林市',
            date: '202102',
            address: '彰化縣員林市員東路一段浮圳南巷98弄2號',
            type: '電梯大樓',
            link: '0718',
            thumbnail: '../images/case/臻品苑.jpg'
          },
          {
            title: '​逸居-彰化驗屋',
            name: '彰化-寬庭',
            area: '彰化縣埔鹽鄉',
            date: '202106',
            address: '彰化縣埔鹽鄉中正路185號',
            type: '透天',
            link: '0805',
            thumbnail: '../images/case/寬庭.jpg'
          },
          {
            title: '​逸居-彰化驗屋',
            name: '彰化-湖北春日',
            area: '彰化縣溪湖鎮',
            date: '202105',
            address: '彰化縣溪湖鎮頂新八街',
            type: '',
            link: '0616',
            thumbnail: '../images/case/湖北春日.jpg'
          }
        ]
      },
      {
        location: '南部地區',
        case: [
          {
            title: '​逸居-嘉義驗屋',
            name: '嘉義-寶格湛',
            area: '嘉義市西區',
            date: '202008',
            address: '嘉義市西區友孝路209號',
            type: '',
            link: '0527',
            thumbnail: '../images/case/寶格湛.jpg'
          },
          {
            title: '​逸居-嘉義驗屋',
            name: '嘉義-流星雨天秤座',
            area: '嘉義市東區',
            date: '202106',
            address: '嘉義市東區吳鳳南路270號',
            type: '',
            link: '0601',
            thumbnail: '../images/case/流星雨天秤座.jpg'
          },
          {
            title: '​逸居-嘉義驗屋',
            name: '嘉義-三貴天空樹',
            area: '嘉義市東區',
            date: '202105',
            address: '嘉義市東區安業街88巷3號',
            type: '',
            link: '0617',
            thumbnail: '../images/case/三貴天空樹.jpg'
          },
          {
            title: '​逸居-台南驗屋',
            name: '台南-南科之心3',
            area: '台南市新市區',
            date: '202108',
            address: '台南市新市區社內63-10號',
            type: '',
            link: '0811',
            thumbnail: '../images/case/南科之心.jpg'
          },
          {
            title: '​逸居-台南驗屋',
            name: '台南-佳展大景',
            area: '台南市安南區',
            date: '202107',
            address: '台南市安南區永續路',
            type: '電梯大樓',
            link: '0823',
            thumbnail: '../images/case/佳展大景.jpg'
          },
          {
            title: '​逸居-台南驗屋',
            name: '台南-未來室',
            area: '台南市新營區',
            date: '202011',
            address: '台南市新營區金華路一段',
            type: '電梯大樓',
            link: '0824',
            thumbnail: '../images/case/未來室.jpg'
          },
          {
            title: '​逸居-台南驗屋',
            name: '台南-V&A2',
            area: '台南市永康',
            date: '201907',
            address: '',
            type: '透天',
            link: '0711',
            thumbnail: '../images/case/台南永康.jpg'
          }
        ]
      }
    ],
    blog: [
      {
        thumbnail: '../images/blog/blog1/1.jpeg',
        name: '熱顯設備等級差異',
        date: '2020年2月7日',
        summary: '',
        content: '<p>今天來跟各位分享介紹一下我們的設備，<br>首先最重要的當然是佔所有設備費用一半的"熱顯像儀"，<br>我們特地跟廠商 <a href="https://www.facebook.com/hashtag/%E8%89%BE%E4%B8%81%E9%99%9E%E5%AF%A6%E6%A5%AD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8?source=feed_text&epa=HASHTAG&__xts__[0]=68.ARCD-PMgGtBoV1BW9E7u4vVyQFLmmdk3MY83VYxGBGXJpCXJ_B_S6YdDXRmXIBgMxU_Q44_ezvuh7cf9acWyJYXIQTMLiHrHaW036E8QjOrCG7HP94R_Q7Da1VbxqOs8DPNQxoiHAQY0WyH9JvuWxHF4alPaVYdVMcPsr4RGSC_PW0zWJXVt3nIlkUgdQfEJ9Z48copRtwC0ZaxZd_teHz31RThhP5Qor29DmYJNd9sK-XwAUYjAQoWE-DX3CJk-1pTr4yio-q3jdvA3Jv8o-jzF8o2LJt1QwhmD0z0WouUEE3dGTOw3q0DbQ5te2H6ZUfJJRI41Q1efx0gFQW24xN4" target="_blank">#艾丁陞實業有限公司</a><br>商借了較低階的熱顯E6來跟逸居目前使用的T530來做比較，<br>費用上兩台價格差了可能快十倍(5萬v.s.50萬的概念)。<br>看下面圖應該可以看到E6的成像照雖然依稀可見滲水處顏色成像與周邊還是有些微不同，<br>但右方T530的成像卻非常明顯的可以顯示出來，<br>並且在操作時的手感順暢度，以及在機子上的畫面反映靈敏度等等差異更大。<br>這最直接影響的當然是我們在現場驗屋時的準確度，以及節省時間成本。<br>所以常有客戶打來問，<br>為什麼業界別人驗屋只要八千，我們卻要上萬?<br><br>首先設備的費用就差了十倍了，<br>再來我們依據屋況大小等，驗屋人員配置2-3人(一般都是3人為主)，<br>若當日排2人則相對會延長驗屋時程，<br>而一般驗屋三房大概都控制在2-3小時結束；<br>但相較價格低廉的同行，驗屋人員只有一位，時間上也是2個小時左右。<br>在此沒有要詆毀同行的意思，每間公司的成本不同，費用當然也會有所差異。<br>這邊只是要讓各位客戶了解花的錢能買到的是什麼樣的服務。<br><br>最後逸居雖然收費比某些同業高....但利潤絕對沒有比較高<br>(大家算一下就知道了...我們一天只能驗兩件，勉強三件，他們的時間可以到四件沒問題)，<br>但不論如何，驗屋品質才是我們一直堅持要把關的。</p><div class="flex-img-3"><div class="img-item"><img src="../images/blog/blog1/1.jpeg"></div><div class="img-item"><img src="../images/blog/blog1/2.jpeg"></div><div class="img-item"><img src="../images/blog/blog1/3.jpeg"></div><div class="img-item"><img src="../images/blog/blog1/4.jpeg"></div><div class="img-item"><img src="../images/blog/blog1/5.jpeg"></div><div class="img-item"><img src="../images/blog/blog1/6.jpeg"></div></div><p>層層把關<br>層層安心<br>您夢想中的好屋，就交給逸居為您把關吧😏<br>請來電04-22816090 讓專人為您詳細說明及預約時段<br>更多詳細資訊請上逸居官網 <a href="https://www.winspectiontw.com/">https://www.winspectiontw.com/</a></p>',
        link: '熱顯設備等級差異'
      },
      {
        thumbnail: '../images/blog/blog2/1.jpeg',
        name: '開口補強筋未施作確實+一例',
        date: '2019年9月24日',
        summary: '',
        content: '<p>這個就是很大機率開口補強筋未施做確實，產生裂縫導致滲水😔😔</p><div class="img-block"><img src="../images/blog/blog2/1.jpeg"><img src="../images/blog/blog2/2.jpeg"></div><p>默哀三分鐘<br>還是趕快找逸居專業驗屋吧!!| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 | 想居住放心安心就找逸居 | <br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '開口補強筋未施作確實-一例'
      },
      {
        thumbnail: '../images/blog/blog3/3.jpeg',
        name: '建築開口防水',
        date: '2019年9月21日',
        summary: '',
        content: '<p>今天逸居小編來跟大家說說另一個常發生滲水的地方🤓<br>先前有跟大家提到衛浴常發生滲水的成因，<br>今天小編就來跟大家說說窗戶的滲水。</p><div class="img-block"><img src="../images/blog/blog3/1.jpeg"></div><p>逸居每次出勤驗屋至少2-3小時以上，大部分的時間都是在進行窗戶的試水，窗戶作為結構體的開口處，若處理不好很容易有滲水的情形。<br>而窗戶滲水可以大致分為下列幾種：<ul><li>◇ 由結構體開口處裂縫導致滲水進入室內</li><li>◇ 窗戶崁縫(塞水路)、或防水施作失敗</li><li>◇ 從窗戶本身窗框間隙滲入</li></ul></p><div class="img-block"><img src="../images/blog/blog3/2.jpeg"></div><p>首先第一種，目前建築法規裡面都有規定，建築物開口處都要進行特別的補強，如下圖</p><div class="img-block"><img src="../images/blog/blog3/3.jpeg"></div><p>紅色虛線為開口部位的斜向補強筋、綠色虛線為水平及垂直向的補強筋，這些補強筋都是避免這些開口在地震來時產生開裂。<br>解決了從結構體裂縫滲入的可能性後，再來就是施作防水：<ul><li>1. 未立窗前，先在開口周邊施作防水層，防水材至少要塗佈距離開口處30cm以上，才能達到較好的防水效果，在窗角處也要加45度玻璃纖維網避免開裂。</li><li>2. 窗框立好後，周邊的縫隙則要進行崁縫處理(也就是塞水路)，將這些縫隙填滿後，再進行施作防水層塗佈。(通常這個步驟完成後，營造廠需要自主檢查進行崁縫處的防水試水。)</li><li>3. 最後比較嚴謹的做法，在外牆粉刷完成後、貼磁磚前會在上一次防水。如此一來就萬無一失了！</li></ul><p>而最後一種"從窗戶本身窗框間隙滲入"這個就比較屬於產品施作上的瑕疵了，主要是窗框鋁料相接處沒有確實緊密接合，或是膠條未調整緊密導致水直接進入室內，這部分可能就得請窗戶施工廠商過來進行調整了。</p><p>目前逸居驗到窗戶滲水大部分都是第二項"窗戶崁縫(塞水路)"的部分沒有做好，導致水滲入室內。買了新房子，結果下雨天一來，屋外下雨、屋內也下雨，多氣人啊，最慘的是裝潢好的房子，還可能因為滲水導致發霉或壞掉，多得不償失啊！</p><p>再搬進去之前，找逸居就是先幫您把問題抓出來，在入住之前把該處理該修繕的一次處理到位，避免日後修繕的麻煩～</p><div class="img-block"><img src="../images/blog/blog3/4.png"></div><p>建商交屋應該注意事項<br>就慢慢的跟大家分享囉~</p><div class="hashtag-block"><a href="">#驗屋</a><br><a href="">#專業高科技儀器</a><br><a href="">#百萬設備</a><br><a href="">#建築師把關</a><br><a href="">#建商交屋</a><br><a href="">#台中驗屋</a><br><a href="">#新屋驗收</a><br><a href="">#交屋</a><br><a href="">#交屋注意事項</a></div><p>層層把關<br>層層安心<br>您夢想中的好屋，就交給逸居為您把關吧😏<br>請來電04-22816090 讓專人為您詳細說明及預約時段<br>更多詳細資訊請上逸居官網 <a href="https://www.winspectiontw.com/">https://www.winspectiontw.com/</a></p><p class="statement">為了避免混淆，特此聲明<br>我們跟"Good Answer 居安心科技檢驗"沒有關係喔!<br>屬於兩間不同的驗屋公司<br>有些人常常搞錯<br><br>市面上很多驗屋公司<br>雖然都有做房屋檢驗<br>但其實大家的專長不太一樣<br>我們是以國家建築師的角度<br>來檢驗工法、施工規範、相關法規</p><p>逸居專業驗屋<br> | 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 | <br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '建築開口防水'
      },
      {
        thumbnail: '../images/blog/blog4/1.png',
        name: '買房子應注意的大小事',
        date: '2019年8月20日',
        summary: '',
        content: '<p>首先當然重要的是區位及價格(不過這不是小編的專業就不多提了)，再來就是評估該建商的過往評價🧐🧐🧐<br>目前逸居接觸到的建商大概可分以下幾種：</p><ul><li>◇ 第一種建商是施工品質管理良好，房屋通常不太有問題，即使有問題也會二話不說馬上處理，不過這種建商一般來說價位也會稍微高一些。👍👍👍</li><li>◇ 而另一種建商則是施工品質不怎麼樣，但處理態度良好，這種建商屬性通常比較偏大型集團，推測可能底下品質管控人員素質不一，造成施工品質落差，不過若發現問題，為維持品牌形象卻是願意處裡的。👍</li><li>◇ 最麻煩的是最後一種建商，施工品質差處理態度也差，遇到這種建商真的只能自求多福了...逸居能幫忙的就是提供現場檢測的結果、數據等證明確實有疏漏，若當初簽的合約又沒看仔細，那就真的欲哭無淚了。👎👎👎</li><li>舉個例來說，最近逸居驗了幾個屋子發現浴室有滲水問題(由浴室側滲出至外面臥室牆面)，很明顯防水出了問題，提出缺失後，建商回覆則是它們浴室防水只做地坪防水(或是只做30cm高)，我們拿蓮蓬頭沖牆面時超過他們防水高度了，是我們檢測方式有誤🙄🙄...而建商合約上防水部分確實也寫僅施做地坪防水，如此一來逸居能幫忙的真的很有限。😭</li><li>所以在這邊提醒各位，買屋前在合約上浴廁防水這塊要特別注意，若是建商寫僅施作地坪防水，也請進行客變加價施作防水，這邊建議最少最少也要100cm(不要低於淋浴出水龍頭的高度，出水水栓為滲水常發生處)，當然可以的話衛浴空間全室施做防水至天花板下是最好的。記得不論是客變或是建商口頭答應施作，皆須留下證據。若建商口頭答應可請建商備註至合約內，避免日後出現爭議時空口無憑。🤐🤐</li><li>今天就先針對防水的部分分享給大家，小編會持續分享更多關於買屋交屋的小知識給各位。<br>以下是逸居進行檢驗時發現的滲漏水照片，可以看出滲水位置大多在60-90cm左右，若防水只施作30cm，您安心嗎?🙄</li></ul><div class="flex-img-2"><div class="img-item"><img src="../images/blog/blog4/1.png"></div><div class="img-item"><img src="../images/blog/blog4/2.png"></div></div><div class="hashtag-block"><a href="">#驗屋</a><br><a href="">#專業高科技儀器</a><br><a href="">#百萬設備</a><br><a href="">#建築師把關</a><br><a href="">#買房更安心</a><br><a href="">#台中驗屋</a></div><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '買房子應注意的大小事'
      },
      {
        thumbnail: '../images/blog/blog5/thumbnail.jpg',
        name: '為何你們收費比別家驗屋公司貴呢?',
        date: '2019年8月20日',
        summary: '',
        content: '<p>有客戶來電時會問，Q：為何你們收費比別家驗屋公司貴呢?<br><br>A：逸居的價格定位也參考了其他同業，事實上皆位於均價中，並沒有特別貴喔，不過確實有聽到某幾個同業的價格特別低，此時各位客戶可以比較看看，可能在專業設備上的成本差異會相當大，例如熱顯像儀，一般較低階的熱顯像儀約莫十萬不到即可入手，但成像的解析度及精度都相差一大截，而逸居使用的熱顯像儀光價格就是一般低階的5倍以上，當然這部分的成本也會攤提在驗屋的費用上。<br>同樣都是熱顯像測漏服務，各家的成本差異卻這麼大，也難怪收費標準會有所差異囉。(陸陸續續逸居也在準備一些比較詳細的介紹影片，讓客戶能更瞭解逸居)<br>在這邊逸居的想法是一棟房子動輒數百甚至上千萬，多花兩三千的驗屋費用，卻能給客戶的是更優質、有保障的服務，這可能才是符合一般客戶所希望的吧。</p><div class="img-block"><img src="../images/blog/blog5/1.jpeg"></div><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '為何你們收費比別家驗屋公司貴呢'
      },
      {
        thumbnail: '../images/blog/blog9/thumbnail.jpg',
        name: '我要如何確保驗屋公司的專業度及驗屋品質呢?',
        date: '2019年8月6日',
        summary: '',
        content: '<p>Q：我要如何確保驗屋公司的專業度及驗屋品質呢?<br><br>A：這題確實比較難回答，但逸居也能理解客戶的心態，畢竟如果花了錢又沒達到應有成效就是浪費了。其實逸居在驗屋時也常常聽到有些同業光怪陸離的檢測方式😵😵😵，也難怪建商會對驗屋公司抱持著不友善的態度了。不過逸居時常在檢測完後，可以感受到建商對我們的改觀，甚至近日檢測完某位客戶的房屋後，建商主動委託我們去檢測公設出現問題的地方，我想這才是一個良好的生態循環。<br>而一般客戶要如何在未驗屋時判斷該公司的專業度呢？<br>首先比較容易的是藉由證照的方式判斷，以我國現行的制度中並無專門的"驗屋師"執照，因此客戶在判斷上就得更加小心，像逸居則是由"建築師"進行驗屋的工作及把關，團隊成員中也有工地主任、乙級配線技術士(甲種電匠)、機電工程師等等，建築師在建築法規、工程監造搭配工地主任在現場實務等互補互成才形成一個完整的團隊，並且以上人員都是常態性的在執行驗屋服務(包含建築師)，決不是只在網站或是廣告文宣中出現而已。<br>最後除了在證照上的確認外，客戶可以隨機對我們進行考試，我相信逸居絕對有足夠的專業可以回答您的疑問(行政小姐就...別考她了😓)。<br><br>層層把關<br>層層安心<br>您夢想中的好屋，就交給逸居為您把關吧😏<br>請來電04-22816090 讓專人為您詳細說明及預約時段</p><div class="hashtag-block"><a href="">#驗屋</a><br><a href="">#專業高科技儀器</a><br><a href="">#百萬設備</a><br><a href="">#建築師把關</a><br><a href="">#買房更安心</a></div><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '我要如何確保驗屋公司的專業度及驗屋品質呢'
      },
      {
        thumbnail: '../images/blog/blog6/1.jpeg',
        name: '百萬級驗屋設備',
        date: '2019年5月31日',
        summary: '',
        content: '<p>在這邊跟大家介紹一下逸居驗屋團隊的百萬級設備！！</p><div class="img-block"><img src="../images/blog/blog6/1.jpeg"></div><p>齊全，舉凡到高階的熱顯像儀、內視鏡、水分計、分貝計、室內甲醛含量檢測、雷射水準儀等等應有盡有，幫您的房屋作最全面性的健檢，讓您在購入新屋的同時，也能更安心的居住。</p><br><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '百萬級驗屋設備'
      },
      {
        thumbnail: '../images/blog/blog7/1.jpeg',
        name: '逸居能為您的房子做些什麼呢?',
        date: '2019年5月8日',
        summary: '',
        content: '<p>現今的不動產交易動輒數百、千萬，但由於房屋的資訊不對等，常常消費者花了大錢，住進新屋後，才發現原來屋內東漏西漏，甚至來個霸王級寒流，屋內磁磚也冷到全部開花(澎共爆裂)，更嚴重的當初建商及工程單位為了省事、省錢，屋內的電線線徑也降了一階，大電量電器使用的地方應該要設置專迴也省了，如此的房子住起來實在叫人膽顫心驚。😖<br>而逸居檢驗團隊，就是利用百萬級的高科技設備儀器，並且依照合約內容、圖說、施工規範、建築、機電、消防等相關法規，幫客戶找出這些潛在的未知缺陷，並提供客戶修繕建議，協助客戶在交屋時，能更全面的了解屋況！減少後續的修繕、爭議問題產生。😤😤<br>下面照片就是逸居團隊實際驗屋時發現的屋況瑕疵<br><br>層層把關<br>層層安心<br>您夢想中的好屋，就交給逸居為您把關吧😏<br>請來電04-22816090 讓專人為您詳細說明及預約時段<br>更多詳細資訊請上逸居官網 <a href="https://www.winspectiontw.com/">https://www.winspectiontw.com/</a></p><div class="hashtag-block"><a href="">#驗屋</a><br><a href="">#專業高科技儀器</a><br><a href="">#百萬設備</a><br><a href="">#建築師把關</a><br><a href="">#買房更安心</a></div><div class="img-block"><img src="../images/blog/blog7/1.jpeg"></div><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居住放心安心就找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: '逸居能為您的房子做些什麼呢'
      },
      {
        thumbnail: '../images/blog/blog8/1.jpeg',
        name: '原來驗屋需要這麼多設備啊！',
        date: '2019年5月8日',
        summary: '',
        content: '<p>逸居在這週一為一位客戶做驗屋服務，這位客戶看到我們團隊大包小包的搬了一堆設備儀器才很驚訝，原來驗屋需要這麼多設備啊！😤😤😤<br>其實建商在交屋時都會幫客戶驗過一次屋況，例如排水暢通測試等等的都會現場測試給客戶看，但排水管若被施工的水泥、砂等等淤積，短期內對排水是不會造成影響的，但由於摩擦變大，再加上又是轉角處，久了這邊就容易卡垢，長而久之排水管就會出現排水不通暢等問題，諸如此類的瑕疵其實都是需要利用一些設備儀器才有辦法檢查到的。<br>而逸居驗屋團隊讓您可以不用花大筆費用添購這些設備去做一次性的檢測，再者檢測出的結果也需要由專業人員進行判讀，逸居團隊在驗屋後除了當場會向客戶或建商工地主任說明本次驗屋成果，報告缺失項目並提供修繕方式建議外，也會在一週內提供驗屋成果報告書電子檔給客戶，讓客戶有所依據。<br>(下圖中就是陽台地排使用內視鏡照管內的現況，已經有水泥砂淤積)</p><div class="img-block"><img src="../images/blog/blog8/1.jpeg"></div><p>逸居專業驗屋<br>| 交屋注意事項 | 台中驗屋 | 台北驗屋 | 新成屋驗屋 | 建商驗收 | 彰化驗屋 |  想居的放心安心找逸居 |<br>| 高雄驗屋 |台南驗屋 | 新屋驗收 | 透天驗屋 | 中古屋驗屋 |</p>',
        link: 'this-is-why-we-need-winspection'
      }
      // },
      // {
      //   thumbnail: '../images/blog/blog1/1.jpeg',
      //   name: '熱顯設備等級差異',
      //   date: '2020年2月7日',
      //   summary: '',
      //   content: '<h2>H1</h2><h3>H2</h3><p>文字文字</p><p>&nbsp;<img class="image_resized" style="width:57.28%;" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGwibTJsmrzErtPg_wFVHOB1IWY0hLuxXpWA&amp;usqp=CAU"><img class="image_resized" style="width:35.64%;" src="https://memeprod.ap-south-1.linodeobjects.com/user-template/36bd85cd7830bb0ccdcfdcdf61210d7e.png"></p>',
      //   link: 'test'
      // }
    ]
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
